import { useMemo } from "react"
import { hasNoTasks, JobType } from "../Models/API/JobModel"
import { hasValue } from "../Models/Client/FetchState"
import { useAppTemplate } from "./useAppTemplate"

export function useShowTaskList(
    appID: string,
    jobType: JobType,
    enableTaskList: boolean = true
): boolean {
    const templateFetch = useAppTemplate(appID)

    return useMemo(() => {
        if (!enableTaskList || !hasValue(templateFetch)) {
            return false
        }

        const { protocol, visibility } = templateFetch.value

        return !hasNoTasks(protocol, visibility, jobType)
    }, [enableTaskList, jobType, templateFetch])
}
